export enum SplitMethod {
  /**
   * 固定量
   */
  FIXED = 0,

  /**
   * 按比例
   */
  PROPORTIONAL = 1,

  /**
   * 等额平分
   */
  EQUALLY = 2
}

export const SplitMethodTextMap = {
  [SplitMethod.FIXED]: '固定量',
  [SplitMethod.PROPORTIONAL]: '按比例',
  [SplitMethod.EQUALLY]: '等额平分'
}
